import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import { useUserAnalytics } from '../../hooks/useAnalytics';
import { useNotifications } from '../../hooks/useNotifications';
import NotificationDropdown from './NotificationDropdown';
import { useFormatting } from '../../hooks/useFormatting';
import './AdminHeader.css';

const AdminHeader = ({ onToggleSidebar }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const { user, logout } = useAdminAuth();
  const location = useLocation();
  const { data: quickStats } = useUserAnalytics('day');
  const { unreadCount } = useNotifications(10, true);
  const { formatNumber } = useFormatting();

  const handleLogout = async () => {
    await logout();
    window.location.reload();
  };

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) return 'Dashboard';
    if (path.includes('/analytics')) return 'Analytics';
    if (path.includes('/users')) return 'Users';
    if (path.includes('/waitlist')) return 'Waitlist';
    if (path.includes('/settings')) return 'Settings';
    return 'Admin Dashboard';
  };

  return (
    <header className="admin-header">
      <div className="header-left">
        <button 
          className="menu-toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle menu"
        >
          <i className="bi bi-list icon-brand"></i>
        </button>
        <h1 className="page-title">{getPageTitle()}</h1>
        {(location.pathname === '/dashboard' || location.pathname === '/admin/dashboard') && quickStats && (
          <div className="header-quick-stats">
            <span className="quick-stat">
              <i className="bi bi-people icon-brand"></i>
                     {formatNumber(quickStats.totalUserCount || 0)}
            </span>
          </div>
        )}
      </div>
      
      <div className="header-right">
        <div className="notification-container">
          <button 
            className="notification-btn" 
            aria-label="Notifications"
            onClick={() => setShowNotifications(!showNotifications)}
            aria-expanded={showNotifications}
          >
            <i className="bi bi-bell icon-brand"></i>
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </button>
          <NotificationDropdown 
            isOpen={showNotifications} 
            onClose={() => setShowNotifications(false)} 
          />
        </div>
        
        <div className="user-menu">
          <button 
            className="user-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
            aria-label="User menu"
            aria-haspopup="menu"
            aria-expanded={showUserMenu}
          >
            <i className="bi bi-person-circle icon-brand"></i>
            <span>{user?.displayName || 'Admin User'}</span>
          </button>
          
          {showUserMenu && (
            <div className="user-dropdown">
              <button className="dropdown-item" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right icon-brand"></i>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
